import { schema } from "normalizr";

export const interiorPreviewSchema = new schema.Entity("interiorPreviews");